import {
  getAcceptTermsOfServiceState,
  getStaticTemplateState,
} from './../../shared/shared.select'
import {
  AcceptTermsOfServiceRequest,
  FetchStaticTemplateRequest,
} from './../../shared/shared.actions'
import { AuthService } from '../../containers/auth/auth.service'
import { LogoutRequest } from './../../containers/auth/auth.actions'
import { select, Store } from '@ngrx/store'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { filter, Subscription } from 'rxjs'
import { getIsAuthenticatedState } from '@containers/auth/auth.selectors'
import { FetchSettingsRequest } from '@containers/settings/settings.actions'
import { TranslateService } from '@ngx-translate/core'
import { CookieService } from 'ngx-cookie-service'
import {
  getSecuritySettingsState,
  getSettingsState,
} from '@containers/settings/settings.selectors'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { ActivatedRoute, NavigationStart, Router } from '@angular/router'
import { UserIdleService } from 'src/app/services/user-idle.service'
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  firstName: string
  lastName: string
  email: string
  roles: string[]
  private state$: Subscription
  inactivitySettings: { [x: string]: boolean | number } = {}
  inactivityTimer: any
  isAuthenticated$: Subscription
  isAuthenticated: boolean
  inactivityTimerCountdown: any
  inactivityTimerCountdownTime: number = 0

  public template$: Subscription
  public showTerms = false
  public termsContent: string
  public titleKey: string
  public acceptTerms$: Subscription
  public termsAccepting = false
  public footer: SafeHtml
  public settings$: Subscription
  public settings: any
  private router$: Subscription
  public currentUrl: string
  public searchVisible: boolean

  constructor(
    public store: Store<any>,
    private authService: AuthService,
    public translateService: TranslateService,
    public cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private userIdleService: UserIdleService,
  ) {
    const { firstName, lastName, roles, email, termsAgreed } =
      authService.getUserInfo()
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
    this.roles = roles.map((r: any) => r.title)
    this.showTerms = !termsAgreed

    this.currentUrl = this.router.url
    this.router$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(({ url }: any) => {
        this.currentUrl = url
      })
  }

  ngOnInit() {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.settings = state.get('data').toJS()
        this.footer = this.sanitizer.bypassSecurityTrustHtml(
          this.settings?.ui?.SETTINGS_UI_FOOTER,
        )
      })
    this.template$ = this.store
      .pipe(select(getStaticTemplateState))
      .subscribe((state) => {
        const data = state.get('data').toJS()

        this.termsContent = data?.content
        this.titleKey = data?.key?.translationKey
      })

    this.acceptTerms$ = this.store
      .pipe(select(getAcceptTermsOfServiceState))
      .subscribe((state) => {
        this.termsAccepting = state.get('isLoading')

        if (state.get('data')) {
          this.showTerms = false
        }
      })

    this.store.dispatch<any>(
      new FetchStaticTemplateRequest(
        'TERMS_OF_SERVICE',
        this.translateService.currentLang,
      ),
    )

    this.state$ = this.store
      .pipe(select(getSecuritySettingsState))
      .subscribe((state) => {
        if (state) {
          this.inactivitySettings = state
          this.inactivityTimerCountdownTime =
            state.SECURITY_INACTIVITY_TIMER_TIMEOUT_MS

          if (this.inactivitySettings.SECURITY_INACTIVITY_TIMER_ENABLED) {
            this.userIdleService.startWatching(
              state.SECURITY_INACTIVITY_TIMER_TIMEOUT_MS,
            )

            this.userIdleService
              .getIdleState()
              .subscribe(({ timeRemaining, isIdle }) => {
                if (isIdle) {
                  this.inactivityTimerCountdownTime = timeRemaining

                  if (timeRemaining === 0) {
                    console.log('User is idle, logging out...')
                    this.userIdleService.stopWatching()
                    this.logout()
                  }
                } else {
                  this.inactivityTimerCountdownTime =
                    state.SECURITY_INACTIVITY_TIMER_TIMEOUT_MS
                }
              })
          }
        }
      })

    this.isAuthenticated$ = this.store
      .pipe(select(getIsAuthenticatedState))
      .subscribe((isAuthenticated) => {
        if (
          isAuthenticated !== this.isAuthenticated &&
          !isAuthenticated &&
          this.isAuthenticated !== undefined
        ) {
          this.userIdleService.stopWatching()
          this.inactivityTimerCountdownTime = 0
        }

        this.isAuthenticated = isAuthenticated
      })

    this.store.dispatch<any>(new FetchSettingsRequest())
  }

  handleClickOutside(e: any) {
    if (
      this.searchVisible &&
      typeof e.target.className === 'string' &&
      !e.target.className?.includes('ng-option-label') &&
      !e.target.className?.includes('ng-option')
    ) {
      this.searchVisible = false
    }
  }

  public get externalDashboardsEnabled() {
    return this.settings?.externalDashboards
      ?.SETTINGS_EXTERNAL_DASHBOARDS_ENABLE
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.isAuthenticated$.unsubscribe()
    this.template$.unsubscribe()
    this.settings$.unsubscribe()
    this.router$.unsubscribe()
    this.userIdleService.stopWatching()

    this.showTerms = true
  }

  logout() {
    this.store.dispatch(new LogoutRequest())
  }

  accept() {
    this.store.dispatch(new AcceptTermsOfServiceRequest())
  }
}
